import React, { useEffect, useRef, useState } from 'react';
import { Grid, Row, Col, Panel, FormGroup, ControlLabel, FormControl, Button, Alert } from 'react-bootstrap';

import Spinner from '../../components/Loaders/Spinner';

import { changePassword } from '../../services/endpoints/general';

const Account = () => {
  const formRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const payload = {
      current_password: formRef.current?.current_password?.value,
      new_password: formRef.current?.new_password?.value,
      confirm_password: formRef.current?.confirm_password?.value,
    };

    setError('');
    try {
      await changePassword(payload);
      setError('');
      setIsLoading(false);
      formRef.current?.reset();
      setSuccess(true);
    } catch (error) {
      setError(error?.data?.error_message ?? 'Something went wrong');
      setIsLoading(false);
    }
  };

  useEffect(() => {
    document.title = 'Settings';
  }, []);

  return (
    <Grid>
      <Row>
        <Col md={6} mdOffset={3}>
          <Panel className="panel-account">
            <Panel.Body>
              <form ref={formRef} onSubmit={onSubmit}>
                {success && !error ? <Alert bsStyle="success">Password changed</Alert> : null}
                {error && <Alert bsStyle="danger">{error}</Alert>}

                <FormGroup>
                  <ControlLabel htmlFor="current_password">Current password</ControlLabel>
                  <FormControl type="password" id="current_password" name="current_password" />
                </FormGroup>
                <FormGroup>
                  <ControlLabel htmlFor="new_password">New password</ControlLabel>
                  <FormControl type="password" id="new_password" name="new_password" />
                </FormGroup>
                <FormGroup>
                  <ControlLabel htmlFor="confirm_password">Confirm password</ControlLabel>
                  <FormControl type="password" id="confirm_password" name="confirm_password" />
                </FormGroup>
                <hr />
                <Button type="submit" bsStyle="primary" disabled={isLoading}>
                  {isLoading && <Spinner />}
                  <span>Change password</span>
                </Button>
              </form>
            </Panel.Body>
          </Panel>
        </Col>
      </Row>
    </Grid>
  );
};

export default Account;
